/**
 * De onde veio o dado que abriu o alerta.
 *
 * `null` na resposta significa **alerta de varredura** — silêncio de dispositivo e
 * score baixo nascem de um job, não da leitura de ninguém, e não têm procedência.
 *
 * ⚠️ **`WATCH` é o dado de dispositivo** — pulseira ou Health Connect, com o mesmo
 * tratamento. É o que marca "origem relógio, não confirmado" na fila
 * (`02-alertas.md` §1.2).
 */
enum AlertOriginEnum {
  WATCH = 'relogio',
  PHOTO = 'foto',
  SELF_REPORTED = 'autorrelato',
  SYMPTOM = 'sintoma',
}

export default AlertOriginEnum;
